export const environment = {
    production: false,
    api_endpoint: 'https://qa.praxiahealth.com/api/v1',
    media_path: 'https://qa.praxiahealth.com/api/v1/files'
};